<script setup lang="ts">
import { useDeviceState } from "@/stores/DeviceState";

withDefaults(
  defineProps<{
    minimal?: boolean;
  }>(),
  {
    minimal: false,
  }
);
const deviceState = useDeviceState();
</script>
<template>
  <div v-if="!deviceState.isOnline" class="px-4 py-3 flex-column">
    <div class="mb-3 d-flex justify-content-center align-items-center">
      <span class="align-items-center d-flex text-muted">
        <i class="bi-wifi-off"></i>
        <span v-if="!minimal" class="ms-2">Offline</span>
      </span>
    </div>
  </div>
</template>
